import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { PlugIcon, SearchIcon, FilterIcon, PlusIcon } from 'lucide-react';
import { IntegrationsCatalogTab } from '../components/integrations/IntegrationsCatalogTab';
import { IntegrationsConnectionsTab } from '../components/integrations/IntegrationsConnectionsTab';
import { IntegrationsHealthTab } from '../components/integrations/IntegrationsHealthTab';
import { IntegrationsFieldMappingTab } from '../components/integrations/IntegrationsFieldMappingTab';
import { IntegrationsSyncsTab } from '../components/integrations/IntegrationsSyncsTab';
import { IntegrationsWebhooksTab } from '../components/integrations/IntegrationsWebhooksTab';
import { IntegrationsAuditTab } from '../components/integrations/IntegrationsAuditTab';
export function IntegrationsPage() {
  const {
    tab
  } = useParams();
  const activeTab = tab || 'catalog';
  const tabs = [{
    id: 'catalog',
    label: 'Catalog'
  }, {
    id: 'connections',
    label: 'My Connections'
  }, {
    id: 'health',
    label: 'Health'
  }, {
    id: 'mapping',
    label: 'Field Mapping'
  }, {
    id: 'syncs',
    label: 'Syncs & Schedules'
  }, {
    id: 'webhooks',
    label: 'Webhooks & Events'
  }, {
    id: 'audit',
    label: 'Audit & Permissions'
  }];
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-5106">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-6 py-4" data-id="element-5107">
        <div className="flex items-center justify-between" data-id="element-5108">
          <div className="flex items-center gap-3" data-id="element-5109">
            <PlugIcon className="w-8 h-8 text-red-600" data-id="element-5110" />
            <div data-id="element-5111">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-5112">
                Integrations Hub
              </h1>
              <p className="text-sm text-gray-600 mt-1" data-id="element-5113">
                Connect, monitor, and govern your data sources
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3" data-id="element-5114">
            <div className="relative" data-id="element-5115">
              <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" data-id="element-5116" />
              <input type="text" placeholder="Search integrations..." className="pl-9 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm w-64" data-id="element-5117" />
            </div>
            {activeTab === 'catalog' && <button className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors" data-id="element-5118">
                <PlusIcon className="w-4 h-4" data-id="element-5119" />
                Connect New
              </button>}
          </div>
        </div>
      </div>
      {/* Tabs */}
      <div className="bg-white border-b border-gray-200 px-6" data-id="element-5120">
        <div className="flex gap-6 overflow-x-auto" data-id="element-5121">
          {tabs.map(t => <a key={t.id} href={`/integrations/${t.id}`} className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeTab === t.id ? 'border-red-600 text-red-600' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-5122">
              {t.label}
            </a>)}
        </div>
      </div>
      {/* Content */}
      <div className="p-6" data-id="element-5123">
        {activeTab === 'catalog' && <IntegrationsCatalogTab data-id="element-5124" />}
        {activeTab === 'connections' && <IntegrationsConnectionsTab data-id="element-5125" />}
        {activeTab === 'health' && <IntegrationsHealthTab data-id="element-5126" />}
        {activeTab === 'mapping' && <IntegrationsFieldMappingTab data-id="element-5127" />}
        {activeTab === 'syncs' && <IntegrationsSyncsTab data-id="element-5128" />}
        {activeTab === 'webhooks' && <IntegrationsWebhooksTab data-id="element-5129" />}
        {activeTab === 'audit' && <IntegrationsAuditTab data-id="element-5130" />}
      </div>
    </div>;
}